import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./villageAchievements.css";

export default function VillageAchievements() {
  const { i18n, t } = useTranslation();
  const [achievements, setAchievements] = useState([]);

  const lang = i18n.language || "ta";

  useEffect(() => {
    axios
      .get("https://admin.cmpranesh-admk.com/api/getVillageAchievements.php")
      .then((res) => {
        setAchievements(res.data);
      });
  }, []);

  return (
    <section className="va-wrapper">

      <div className="va-title-box">
        <h2 className="va-village-title">
          {t("achievement_main_title")}
        </h2>
        <p className="va-subtitle">
          {t("achievement_subtitle")}
        </p>
      </div>

      <div className="va-card-container">
        {achievements.map((item, index) => (
          <div key={index} className="va-achievement-card">

            <div className="va-col va-work">
              <span className="va-label">
                {t("achievement_work_label")}
              </span>
              <p className="va-value">
                {lang === "ta" ? item.work_ta : item.work_en}
              </p>
            </div>

            <div className="va-col va-details">
              <span className="va-label">
                {t("achievement_details_label")}
              </span>
              <p className="va-value">
                {lang === "ta" ? item.details_ta : item.details_en}
              </p>
            </div>

            <div className="va-col va-budget">
              <span className="va-label">
                {t("achievement_budget_label")}
              </span>
              <p className="va-budget-amount">₹{item.budget}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
}
